export const datesAreEqual = (date1: Date | null, date2: Date | null) => {
  if (!date1 && !date2) {
    return true;
  }
  if (!date1 || !date2) {
    return false;
  }
  return (
    date1.getUTCFullYear() === date2.getUTCFullYear() &&
    date1.getUTCMonth() === date2.getUTCMonth() &&
    date1.getUTCDate() === date2.getUTCDate()
  );
};

export const isValidDate = (date: unknown): date is Date =>
  (date instanceof Date || typeof date === 'string') &&
  !Number.isNaN(new Date(date).getTime());

export const isLeapYear = (year: number) =>
  (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;

/**
 * @returns The updated date instance where the time is set to midnight (start of day)
 */
export const setStartOfDay = (date: Date) => {
  const d = new Date(date);
  d.setHours(0);
  d.setMinutes(0);
  d.setSeconds(0);
  d.setMilliseconds(0);
  return d;
};

/**
 * @returns The updated date instance where the time is set to just before midnight next day (end of day)
 */
export const setEndOfDay = (date: Date) => {
  const d = new Date(date);
  d.setHours(23);
  d.setMinutes(59);
  d.setSeconds(59);
  d.setMilliseconds(999);
  return d;
};

export const daysInMonth = (month: number, year: number) =>
  new Date(year, month, 0).getDate();

export const isDateInRange = (date: Date, minDate?: Date, maxDate?: Date) => {
  const min = minDate?.getTime() || Number.MIN_SAFE_INTEGER;
  const max = maxDate?.getTime() || Number.MAX_SAFE_INTEGER;

  return min <= date.getTime() && date.getTime() <= max;
};
